// extracted by mini-css-extract-plugin
export default {"container":"edi_jnVsr","title":"edi_tit_2g-0j"};